import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../header/header.component';

@Component({
  selector: 'app-myspace-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './myspace-layout.component.html',
  styleUrl: './myspace-layout.component.scss'
})
export class MyspaceLayoutComponent {

}
